import Swiper, { Navigation, Pagination } from 'swiper'
import { hideScroll, resetScroll } from './helpers/scroll'

const handleSiteHeaderBurger = () => {
  const burger = document.querySelector<HTMLButtonElement>(
    '.site-header-burger'
  )
  const mobileNav = document.querySelector('.mobile-nav')

  if (!burger || !mobileNav) return

  const showMobileNav = () => {
    mobileNav.classList.add('mobile-nav--visible')
    burger.setAttribute('aria-expanded', 'true')
  }

  const hideMobileNav = () => {
    mobileNav.classList.remove('mobile-nav--visible')
    burger.setAttribute('aria-expanded', 'false')
  }

  burger.addEventListener('click', () => {
    if (burger.classList.contains('site-header-burger--active')) {
      resetScroll()
      hideMobileNav()
    } else {
      hideScroll()
      showMobileNav()
    }

    burger.classList.toggle('site-header-burger--active')
  })
}

handleSiteHeaderBurger()

const handleMobileNav = () => {
  const children = document.querySelectorAll<HTMLAnchorElement>(
    '.mobile-nav-list .menu-item-has-children > a'
  )

  Array.from(children).forEach((c) => {
    c.addEventListener('click', (e) => {
      e.preventDefault()
      const elem = e.currentTarget as HTMLAnchorElement
      const isElemActive = elem.classList.contains('is-active')

      if (isElemActive) {
        return elem.classList.remove('is-active')
      }

      document.querySelector('.is-active')?.classList.remove('is-active')

      return elem.classList.add('is-active')
    })
  })
}

handleMobileNav()

const handleReadMore = () => {
  const el = document.querySelector('.read-more-card-rm')
  const trigger = document.querySelector('.read-more-card-trigger')

  if (!el || !trigger) return

  const initialText = trigger.textContent || 'Rozwiń tekst'

  trigger.addEventListener('click', (e) => {
    e.preventDefault()
    if (el.classList.contains('hidden')) {
      el.classList.remove('hidden')
      trigger.textContent = 'Zwiń tekst'
      return
    }

    el.classList.add('hidden')
    trigger.textContent = initialText
  })
}

handleReadMore()

const handleExcerptSwiper = () => {
  new Swiper('.latest-posts .swiper', {
    modules: [Navigation, Pagination],

    slidesPerView: 1,
    spaceBetween: 10,

    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      769: {
        slidesPerView: 2,
      },
      1020: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1281: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },

    pagination: {
      el: '.latest-posts .swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.latest-posts .swiper-button-next',
      prevEl: '.latest-posts .swiper-button-prev',
    },
  })
}

handleExcerptSwiper()
